<template>
  <font face="Noto Sans JP" size="5" >
  <div>
    <router-link to="/mypage" style="text-decoration: none"><span class="regist-back-link">マイページへ</span></router-link>
    <h2 style="text-align:center"> ユーザー情報</h2>
    <br>
    <hr noshade>
    <br>
    <h1>{{ user.user.name }}</h1>
    <br>
    <div style="font-size:32px;text-align:center">
      <p>{{ user.user_detail.department }}</p>
      <p>学籍番号:{{ user.user_detail.student_id }}</p>
      <p>{{ user.user_detail.grade }}</p>
      <br>
      <p>{{ user.user_detail.tel }}</p>
      <p>{{ user.user.email }}</p>
    </div>
    <br>
  </div>
 </font>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: null
    }
  },
  mounted() {
    if (this.$store.state.userInfoPermission == false) {
      this.$router.push("/mypage");
    }
    const url = process.env.VUE_APP_URL + "/api/v1/current_user";
    axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "access-token": localStorage.getItem("access-token"), 
        "client": localStorage.getItem("client"),
        "uid": localStorage.getItem("uid"),
      },
    }).then((response) => {
      this.user = response.data.data
    })
  },
  methods: {
    backMypage() {
      this.$store.commit("acceptUserInfoPermission");
      this.$router.push("/mypage");
    }
  }
}
</script>

<style scoped>
hr {
  height: 0.1rem;
    border-color: #e0e0e0;
}
h5{
  color: #CF4DF3;
}
</style>